import React from 'react';
import classnames from 'classnames';

import styles from './text.module.scss';

const baseClass = 'text';

export type TextProps = {
  tag?: 'p' | 'span';
  variant?:
    | 'paragraph-100'
    | 'paragraph-200'
    | 'caption-100'
    | 'caption-200'
    | 'caption-200-fixed'
    | 'caption-300'
    | 'caption-300-fixed'
    | 'label-100'
    | 'label-200'
    | 'legal-100';
} & Pick<React.HTMLAttributes<HTMLParagraphElement>, 'children' | 'className' | 'id'>;

export const Text: React.FC<TextProps> = ({ children, className, tag = 'p', id, variant = 'paragraph-100' }) => {
  const classes = classnames(styles.text, styles[`${baseClass}--${variant}`], className);
  const Tag = tag;
  return (
    <Tag className={classes} id={id}>
      {children}
    </Tag>
  );
};
